import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import { reactLocalStorage } from 'reactjs-localstorage';

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";

import { API_URL } from "../constant";
import Loader from "../front/loading";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-responsive";

import $ from 'jquery';


function IssuedItem() {
  const navigat = useNavigate();
  const [userData, setUserData] = useState([]);
  const [userItem, setUserItem] = useState([]);
  const inputTypeRef = React.useRef();
  const inputTypeRefType = React.useRef();

  const [isLoading, setIsLoading] = useState(true);
  $('#example').DataTable().destroy();
  $(document).ready(function () {
    $('#example').DataTable({
      destroy: true,
      'aoColumnDefs': [{
        'bSortable': false,
        'aTargets': ['nosort']
      }],
      dom: 'Bfrtip',
      buttons: ['copy', 'csv', 'excel', 'pdf', 'print']
    });
    var dt = $('#example').DataTable();
    dt.columns([0, 1, 2]).visible(false);

  });
  const params = useParams();
  useEffect(() => {
    document.title = "Issued Item History";
    getItemData();
    getItemList();
  }, [1]
  );
  /************Get all state data********************** */
  let getItemData = async (type = "", item = "") => {
    let user_type_id = '';
    if (reactLocalStorage.get("userLoginType") == "Admin") {
      user_type_id = 'admin';
    }
    if (reactLocalStorage.get("userLoginType") == "District"  || reactLocalStorage.get("userLoginType") == "DistrictStore" ) {
      user_type_id = reactLocalStorage.get("district");;
    }
    if (reactLocalStorage.get("userLoginType") == "Chc" || reactLocalStorage.get("userLoginType") == "Store") {
      user_type_id = reactLocalStorage.get("user_id");
    }
    let formData = {
      'req_to': user_type_id,
      'type': type,
      'item': item
    };
    const res = await axios.post(API_URL + 'admin/get-all-issued-item-list', formData).then(ress => {
      setUserData(ress.data.Rdata);
      setIsLoading(false);
    });
  }
  /****************************************** */

  const settingPre = () => {
    inputTypeRefType.current.value = ""
  }
  const settingPre1 = () => {
    inputTypeRef.current.value = ""
  }

  /************Get all item data********************** */
  let getItemList = async (type = "") => {
    let data = { 'type': type };
    const res = await axios.post(API_URL + 'admin/item_list', data).then(ress => {
      // console.log(ress.data);
      setUserItem(ress.data.Rdata);
      setIsLoading(false);
    });
  }

  /******************Redirecting to edit page***************************** */
  let editUser = (id) => {
    //console.warn("id="+data);
    return navigat('/edit_inv_item/' + id);
  }

  let editItem = (id) => {
    // console.log("id="+id);
    return navigat('/getDetailsOfIssuedItem/' + id);
  }
  const handleFilter = (event, item = '') => {
    getItemData(event.target.value, item);
  }

  const handleFilterItem = (type = '', event) => {
    getItemData(type, event.target.value);
  }
  return (

    <div className="container-scroller">

      <Hor_header />

      <div className="container-fluid page-body-wrapper">

        <Ver_header />

        <div className="main-panel">
        {isLoading ? (<Loader />) : (
          <>
          <div className="content-wrapper">
            <div className="row">

              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Issued Item Histroy </h4>

                    
                      <div className="table-responsive pt-3">
                        <select onChange={(e) => { handleFilterItem('', e); settingPre1(); }} ref={inputTypeRefType} className="search-option-s">
                          <option value="">Item List </option>
                          {userItem.map(item => (
                            <option value={item.id}>{item.item_name}</option>
                          ))}
                        </select>

                        <select onChange={(e) => { handleFilter(e, ''); settingPre(); }} ref={inputTypeRef} className="search-option">
                          <option value="">Item Type</option>
                          <option value="Consumable">Consumable</option>
                          <option value="Non consumable">Non Consumable</option>
                        </select>

                        <table className="table table-bordered display  nowrap" id="example">
                          <thead>
                            <tr>

                              <th>Requested To</th>
                              <th>Item Type</th>
                              <th>Requested By-Id</th>
                              <th>Action</th>
                              <th>Requested By</th>
                              <th>Item</th>
                              <th>Requested Quantity</th>
                              <th>Issued Quantity</th>

                            </tr>
                          </thead>
                          <tbody>
                            {userData.map((udata, index) => (
                              <tr key={index}>
                                <td> {reactLocalStorage.get('user_name')}</td>
                                <td> {udata.type}</td>
                                <td> {udata.req_by}</td>
                                <td>
                                  <button type="button" className="btn btn-outline-secondary btn-rounded btn-icon" title="Detail page" onClick={() => { editItem(udata.req_by) }}>
                                    <i className="typcn typcn-edit  text-secondary"></i>
                                  </button>
                                </td>
                                <td> {udata.req_by_name}</td>
                                <td> {udata.item_name}</td>
                                <td> {udata.sum_req}</td>
                                <td> {udata.sum_giv_qty}</td>

                              </tr>
                            )
                            )}

                          </tbody>
                        </table>
                      </div>
                   
                  </div>
                </div>
              </div>


            </div>
          </div>

          <Footer />
          </>
          )}
        </div>

      </div>

    </div>);
}

export default IssuedItem;